
import { Button } from '@/components/ui/button';
import { FileText } from 'lucide-react';
import { useToast } from "@/hooks/use-toast";

type DownloadButtonsProps = {
  content: string;
};

const DownloadButtons = ({ content }: DownloadButtonsProps) => {
  const { toast } = useToast();

  const handlePdfDownload = async () => {
    try {
      if (!content || content.trim() === '') {
        throw new Error("No content available to download");
      }
      
      console.log("Starting PDF export process");
      
      // Export the content to PDF directly using the imported function
      await import('./export/pdfExporter').then(module => {
        return module.exportToPdf(content, toast);
      });
      
      // Show success message
      toast({
        title: "Success",
        description: "PDF download started",
        duration: 3000,
      });
    } catch (error) {
      console.error("Error during PDF export:", error);
      toast({
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to download PDF. Please try again.",
        variant: "destructive",
        duration: 5000,
      });
    }
  };

  return (
    <div className="flex flex-row lg:flex-col gap-2 lg:ml-4">
      <Button
        onClick={handlePdfDownload}
        variant="outline"
        size="sm"
        className="flex items-center gap-1 text-blue-400 hover:text-blue-300 hover:bg-blue-900/20 transition-all duration-300 border-blue-700/30 hover:border-blue-500/50 group"
        title="Download as PDF"
      >
        <FileText className="h-3 w-3 group-hover:scale-110 transition-transform" />
        <span className="text-xs">PDF</span>
      </Button>
    </div>
  );
};

export default DownloadButtons;
